import {
  Button,
  Dialog,
  DialogContent,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import Cookies from 'js-cookie';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LANG_DEFAULT } from 'sysconfig';
import { ImageFallback } from 'utils';
import { formatCurrency } from 'utils/FormatNumber';
import styles from './styles.module.css';

const CurrencyPopup = ({
  paymentMethod,
  open,
  onClose,
  handleSubmit,
  cartTotalPrice,
  cartTotalUsdPrice,
  currencySelected,
  setCurrencySelected,
}) => {
  const locale = Cookies.get('NEXT_LOCALE') || LANG_DEFAULT;
  const { t } = useTranslation('checkout');
  const currencyOptions = useMemo(
    () =>
      paymentMethod?.currency?.map((method) => ({
        ...method,
        title: method[`name_${locale}`] ?? method.name,
        totalPrice:
          method.code === 'USD'
            ? formatCurrency(cartTotalUsdPrice, ',', '$')
            : formatCurrency(Math.max(0, cartTotalPrice)),
      })),
    [paymentMethod, cartTotalPrice, cartTotalUsdPrice],
  );

  const handleChange = (event) => {
    setCurrencySelected(event.target.value);
  };

  if (!currencyOptions) {
    return <></>;
  }

  return (
    <Dialog open={open} maxWidth="xs" fullWidth classes={styles.currencyPopup}>
      <DialogContent style={{ textAlign: 'center', padding: '16px 20px 20px' }}>
        <ImageFallback
          src="/icons/credit_card_green.svg" // Replace with your icon path
          alt="Wallet Icon"
          width={40}
          height={40}
          style={{ marginBottom: '20px' }}
        />
        <Typography
          variant="body1"
          style={{
            lineHeight: '24px',
            fontSize: '20px',
            fontWeight: 800,
            fontFamily: 'ggsm',
            marginBottom: '8px',
          }}
        >
          {t('currency_popup.title')}
        </Typography>
        <Typography
          variant="body2"
          style={{
            lineHeight: '20px',
            fontSize: '16px',
            fontWeight: 400,
            fontFamily: 'ggsr',
            color: '#0A0A0A',
          }}
        >
          {t('currency_popup.sub_title')}
        </Typography>
        <div
          style={{
            display: 'grid',
            gap: 24,
            margin: '20px 0px',
            padding: '16px',
            border: '1px solid #F0F0F0',
            borderRadius: '8px',
          }}
        >
          {currencyOptions.map((method) => (
            <RadioGroup
              className={styles.fieldset}
              style={{ gap: 12 }}
              onChange={handleChange}
              value={currencySelected}
              key={method.code}
            >
              <FormControlLabel
                className={`${currencySelected === method.code ? 'active_payment' : ''}`}
                disabled={!method.isActive}
                value={method.code}
                control={
                  <Radio
                    classes={{
                      root:
                        currencySelected === method.code
                          ? styles.checkbox_color
                          : styles.noncheckbox_color,
                    }}
                    size="small"
                  />
                }
                label={
                  <Grid container alignItems="center" justifyContent="space-between">
                    <Grid item container direction="column" alignItems="left">
                      <Grid item>
                        <Typography
                          variant="body1"
                          style={{
                            textAlign: 'left',
                            fontSize: '16px',
                            fontWeight: 400,
                            fontFamily: 'ggsr',
                            color: currencySelected === method.code ? '#005C29' : '#000000de',
                          }}
                        >
                          {method.title}
                        </Typography>
                      </Grid>
                      {method.isActive ? (
                        <Grid item>
                          <Typography
                            variant="body1"
                            style={{
                              textAlign: 'left',
                              fontSize: '20px',
                              fontWeight: 700,
                              fontFamily: 'ggsm',
                            }}
                          >
                            {method.totalPrice}
                          </Typography>
                        </Grid>
                      ) : (
                        <Grid item>
                          <Typography
                            variant="body1"
                            style={{
                              textAlign: 'left',
                              fontSize: '16px',
                              fontWeight: 400,
                              fontFamily: 'ggsr',
                              color: '#0E1983',
                            }}
                          >
                            {t('currency_popup.currency_unavailable')}
                          </Typography>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                }
              />
            </RadioGroup>
          ))}
        </div>

        <Grid container justifyContent="center">
          <Grid item xs={4}>
            <Button
              onClick={onClose}
              style={{ color: '#666', fontWeight: 600, borderRadius: '8px' }}
            >
              {t('currency_popup.cancel')}
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              onClick={handleSubmit}
              type="submit"
              variant="contained"
              color="primary"
              style={{ backgroundColor: '#005C29', fontWeight: 600, borderRadius: '8px' }}
            >
              {t('currency_popup.continue')}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CurrencyPopup;
